import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { InputFileModule } from 'ngx-input-file';
import {HomepageComponent} from "./homepage.component";
import { BannersComponent } from './banners/banners.component';
import {BannerDialogComponent} from "./banners/banner-dialog/banner-dialog.component";
import { SliderComponent } from './slider/slider.component';
import {SliderDialogComponent} from "./slider/slider-dialog/slider-dialog.component";
import {VideoComponent} from "./video/video.component";
import {VideoDialogComponent} from "./video/video-dialog/video-dialog.component";

export const routes = [
    { path: 'banners', component: BannersComponent, data: { breadcrumb: 'Banners' } },
    { path: 'slider', component: SliderComponent, data: { breadcrumb: 'slider' } },
    { path: 'background', component: VideoComponent, data: { breadcrumb: 'video' } },
];

@NgModule({
    declarations: [
       HomepageComponent,
       BannersComponent,
       BannerDialogComponent,
       SliderComponent,
       SliderDialogComponent,
       VideoComponent,
       VideoDialogComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        ReactiveFormsModule,
        SharedModule,
        NgxPaginationModule,
        SwiperModule,
        InputFileModule
    ]
})
export class HomepageModule { }
